import UserManual from "./UserManual";
export default UserManual;